import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from './api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);

/**
 * 标准埋点
 * @param {*} params
 */
export const warehouseCollectionSaveStandardCollectionData = (params, config) => {
  if (window?.ssrConfig?.routerConfig?.short?.shortID) {
    for (const e of params.standardCollectionDatas) {
      e.ext = e?.ext ?? {};
      e.ext.shortID = window.ssrConfig.routerConfig.short.shortID;
    }
  }
  return defaultCurl(params, `warehouse/collection/saveStandardCollectionData.do`, config)
};

/**
 * 其他埋点
 * @param {*} params 
 * @param {*} config 
 * @returns 
 */
export const warehouseCollectionSaveOtherCollectionData = (params, config) => {
  if (window?.ssrConfig?.routerConfig?.short?.shortID) {
    for (const e of params.otherCollectionDatas) {
      e.ext = e?.ext ?? {};
      e.ext.shortID = window.ssrConfig.routerConfig.short.shortID;
    }
  }
  return defaultCurl(params, `warehouse/collection/saveOtherCollectionData.do`, config);
}
// export const warehouseCollectionSaveOtherCollectionData = (params, config) => new Promise(re => {
//   const ret = {
//     "rspCd": "00000",
//     "rspInf": "success",
//     "rspType": 0,
//     "data": null,
//     "v": "1",
//     "responseTm": "20231108143329"
//   }
//   config?.success?.(ret.data);
//   re(ret)
// })